import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
    typography: {
      fontFamily: [
        "Nunito",
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ].join(",")
    },
    palette: {
      primary: {
        main: "#1a76d2"
      }
    }
  });

export default theme;